import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SEOHead from "../components/SEO/SEOHead";
import { FaCompass, FaHotel, FaMapMarkedAlt, FaHome, FaShieldAlt } from "react-icons/fa";

export default function NotFoundPage() {
  return (
    <div className="not-found-page-wrapper" style={{ minHeight: "100vh", display: "flex", flexDirection: "column", background: "#f8fafc" }}>
      <SEOHead
        title="Page Not Found (404) | Soloway Sri Lanka"
        description="The page you are looking for might have been removed, had its name changed, or is temporarily unavailable. Return to Soloway to explore verified Sri Lanka hotels and guides."
        noIndex={true}
        canonicalUrl="/404"
      />
      <Navbar />

      <main style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "4rem 1.5rem" }}>
        <div style={{ maxWidth: "640px", width: "100%", textAlign: "center", background: "#ffffff", padding: "3rem 2rem", borderRadius: "1.25rem", boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.01)" }}>
          <div style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: "80px", height: "80px", borderRadius: "50%", background: "#ecfdf5", color: "#0d9488", fontSize: "2.5rem", marginBottom: "1.5rem" }}>
            <FaCompass />
          </div>

          <h1 style={{ fontSize: "2.25rem", fontWeight: "800", color: "#0f172a", marginBottom: "0.75rem", letterSpacing: "-0.025em" }}>
            404 - Page Not Found
          </h1>

          <p style={{ fontSize: "1.0625rem", color: "#64748b", lineHeight: "1.6", marginBottom: "2rem" }}>
            We couldn't find the island destination or page you were looking for. It may have moved or no longer exists. Let's get you back on track:
          </p>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "1rem", marginBottom: "2rem", textAlign: "left" }}>
            <Link
              to="/"
              style={{ display: "flex", alignItems: "center", gap: "0.75rem", padding: "0.875rem 1rem", background: "#f1f5f9", borderRadius: "0.75rem", textDecoration: "none", color: "#1e293b", fontWeight: "600", transition: "all 0.2s ease" }}
            >
              <FaHome style={{ color: "#0d9488" }} /> Home Platform
            </Link>

            <Link
              to="/sri-lanka-hotels"
              style={{ display: "flex", alignItems: "center", gap: "0.75rem", padding: "0.875rem 1rem", background: "#f1f5f9", borderRadius: "0.75rem", textDecoration: "none", color: "#1e293b", fontWeight: "600", transition: "all 0.2s ease" }}
            >
              <FaHotel style={{ color: "#2563eb" }} /> Browse Stays & Hotels
            </Link>

            <Link
              to="/sri-lanka-guides"
              style={{ display: "flex", alignItems: "center", gap: "0.75rem", padding: "0.875rem 1rem", background: "#f1f5f9", borderRadius: "0.75rem", textDecoration: "none", color: "#1e293b", fontWeight: "600", transition: "all 0.2s ease" }}
            >
              <FaCompass style={{ color: "#7c3aed" }} /> Find Tour Guides
            </Link>

            <Link
              to="/most-famous-places-sri-lanka"
              style={{ display: "flex", alignItems: "center", gap: "0.75rem", padding: "0.875rem 1rem", background: "#f1f5f9", borderRadius: "0.75rem", textDecoration: "none", color: "#1e293b", fontWeight: "600", transition: "all 0.2s ease" }}
            >
              <FaMapMarkedAlt style={{ color: "#d97706" }} /> Famous Places Guide
            </Link>

            <Link
              to="/policies"
              style={{ display: "flex", alignItems: "center", gap: "0.75rem", padding: "0.875rem 1rem", background: "#f1f5f9", borderRadius: "0.75rem", textDecoration: "none", color: "#1e293b", fontWeight: "600", transition: "all 0.2s ease" }}
            >
              <FaShieldAlt style={{ color: "#475569" }} /> Policies & Support
            </Link>
          </div>

          <Link
            to="/"
            style={{ display: "inline-block", background: "linear-gradient(135deg, #0d9488, #0f766e)", color: "#ffffff", padding: "0.75rem 2rem", borderRadius: "0.5rem", fontWeight: "600", textDecoration: "none", boxShadow: "0 4px 6px -1px rgba(13, 148, 136, 0.2)" }}
          >
            Return to Homepage
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
}
